import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  DrugAlcoholRecordActions,
  DrugAlcoholRecordActionTypes,
} from './drug-alcohol-record.actions';
import { DrugAlcoholRecordEntity } from './drug-alcohol-record.model';

export type DrugAlcoholRecordEntities = EntityState<DrugAlcoholRecordEntity>;

export const adapter: EntityAdapter<DrugAlcoholRecordEntity> =
  createEntityAdapter<DrugAlcoholRecordEntity>();

export const initialState: DrugAlcoholRecordEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): DrugAlcoholRecordEntities {
  const action = incomingAction as DrugAlcoholRecordActions;
  switch (action.type) {
    case DrugAlcoholRecordActionTypes.AddDrugAlcoholRecord: {
      return adapter.addOne(action.payload.drugAlcoholRecord, state);
    }

    case DrugAlcoholRecordActionTypes.UpsertDrugAlcoholRecord: {
      return adapter.upsertOne(action.payload.drugAlcoholRecord, state);
    }

    case DrugAlcoholRecordActionTypes.AddDrugAlcoholRecords: {
      return adapter.addMany(action.payload.drugAlcoholRecords, state);
    }

    case DrugAlcoholRecordActionTypes.UpsertDrugAlcoholRecords: {
      return adapter.upsertMany(action.payload.drugAlcoholRecords, state);
    }

    case DrugAlcoholRecordActionTypes.UpdateDrugAlcoholRecord: {
      return adapter.updateOne(action.payload.drugAlcoholRecord, state);
    }

    case DrugAlcoholRecordActionTypes.UpdateDrugAlcoholRecords: {
      return adapter.updateMany(action.payload.drugAlcoholRecords, state);
    }

    case DrugAlcoholRecordActionTypes.DeleteDrugAlcoholRecord: {
      return adapter.removeOne(action.payload.id, state);
    }

    case DrugAlcoholRecordActionTypes.DeleteDrugAlcoholRecords: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case DrugAlcoholRecordActionTypes.LoadDrugAlcoholRecords: {
      return adapter.setAll(action.payload.drugAlcoholRecords, state);
    }

    case DrugAlcoholRecordActionTypes.ClearDrugAlcoholRecords: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
